import _ from "lodash";

export type ParentWindowReceivedMessageType =
  | "resized"
  | "urlChanged"
  | "hangup"
  | "enableCamera"
  | "disableCamera"
  | "switchCamera"
  | "enableMicrophone"
  | "disableMicrophone"
  | "switchMicrophone";

export type WindowSizePreset =
  | "fullscreen"
  | "halfscreen"
  | "quarterscreen"
  | "initial"
  | "minimized";

export const sendParentWindowMessage = (
  message:
    | {
        type: "windowResize";
        preset: WindowSizePreset;
      }
    | {
        type: "statusChanged";
        status:
          | "placingCall"
          | "onCall"
          | "failure"
          | "noExperts"
          | "callEnded";
        message?: string;
      }
    | {
        type:
          | "close"
          | "getSize"
          | "getWindowUrl"
          | "microphoneEnabled"
          | "microphoneDisabled"
          | "cameraEnabled"
          | "cameraDisabled";
      }
    | {
        type: "microphoneSwitched";
        microphone: {
          microphone: MediaDeviceInfo;
          isActive: boolean;
        };
      }
    | {
        type: "cameraSwitched";
        camera: {
          camera: MediaDeviceInfo;
          isActive: boolean;
        };
      }
    | {
        type: "microphoneListChanged";
        microphones: {
          microphone: MediaDeviceInfo;
          isActive: boolean;
        }[];
      }
    | {
        type: "cameraListChanged";
        cameras: {
          camera: MediaDeviceInfo;
          isActive: boolean;
        }[];
      }
    | { type: "setWindowUrl"; url: string }
    | string
) => {
  console.log("Sending message to parent window: ", message);

  window.parent?.postMessage(JSON.parse(JSON.stringify(message)), "*");
};

export const listenParentWindowMessages = (
  callbacks: Partial<Record<ParentWindowReceivedMessageType, Function>>
) => {
  console.log("Listening parent window messages");

  window.addEventListener("message", event => {
    console.log("Received message from parent window: ", event.data);

    const type = event.data.type;

    if (!(type in callbacks)) {
      return;
    }

    callbacks?.[type as ParentWindowReceivedMessageType]?.(
      _.omit(event.data, "type")
    );
  });
};
